<template>
    <div class="p-2 text-center ex-page-content">
        <img width="300" alt="unavailable" :src="unavailableSVG"/>
        <h2 class="text-muted m-t-20 mb-2" v-html="unavailableText"/>
    </div>
</template>

<script>
export default {
    name: "APIUnavailable",
    computed: {
        unavailableSVG() {
            const section = this.$firstSectionPath;
            return require(`../../../assets/svg/unavailable_${section}.svg`);
        },
        unavailableText() {
            const section = this.$firstSectionPath;
            return this.$t(`APIUnavailable.${section}`);
        },
    },
};
</script>

<style scoped>

</style>